// extracted by mini-css-extract-plugin
module.exports = {"layoutContainer":"layout_layoutContainer__1kI95","layoutMain":"layout_layoutMain__o3ZEK"};